/**
 * A barra lateral recolhida na mesa do perito (E205.F1.T05, ADR-0147 §8).
 *
 * Na mesa a barra abre recolhida (só os ícones), para o exame e o original ao lado terem a largura;
 * o botão da barra a expande. A escolha fica no navegador, por pessoa (a chave leva o id de quem
 * entrou). Fora da mesa a barra é a de sempre e a escolha não vale. O armazenamento pode faltar (aba
 * privada, dados bloqueados): sem ele a barra segue recolhida na mesa e o botão funciona até sair.
 */
import { useCallback, useState } from 'react';

const CHAVE = 'signcheck.barraLateral.mesa';
const RECOLHIDA = 'recolhida';
const EXPANDIDA = 'expandida';

function chaveDa(pessoa: string | null): string {
  return `${CHAVE}.${pessoa ?? 'sessao'}`;
}

export function lerBarraRecolhida(pessoa: string | null): boolean | null {
  try {
    const valor = window.localStorage.getItem(chaveDa(pessoa));
    if (valor === RECOLHIDA) return true;
    if (valor === EXPANDIDA) return false;
    return null;
  } catch {
    return null;
  }
}

function gravarBarraRecolhida(pessoa: string | null, recolhida: boolean): void {
  try {
    window.localStorage.setItem(chaveDa(pessoa), recolhida ? RECOLHIDA : EXPANDIDA);
  } catch {
    // Sem armazenamento, a escolha vale até sair da tela.
  }
}

export interface BarraDaMesa {
  /** A barra está recolhida agora (só na mesa). */
  recolhida: boolean;
  /** A barra pode recolher (a tela é a mesa). */
  recolhivel: boolean;
  alternar: () => void;
}

export function useBarraRecolhidaNaMesa(naMesa: boolean, pessoa: string | null): BarraDaMesa {
  const [escolha, setEscolha] = useState<{ pessoa: string | null; recolhida: boolean } | null>(
    null,
  );
  const preferida =
    escolha !== null && escolha.pessoa === pessoa
      ? escolha.recolhida
      : (lerBarraRecolhida(pessoa) ?? true);
  const recolhida = naMesa && preferida;
  const alternar = useCallback(() => {
    const nova = !preferida;
    gravarBarraRecolhida(pessoa, nova);
    setEscolha({ pessoa, recolhida: nova });
  }, [preferida, pessoa]);
  return { recolhida, recolhivel: naMesa, alternar };
}
